/**
 * 失敗時のバイブレーション。長めの振動を繰り返すパターン。
 */
export const vibrateError = () => {
  try {
    if (typeof navigator === "undefined" || !navigator.vibrate) return;
    navigator.vibrate([200, 100, 200, 100, 200]);
  } catch {
    // バイブレーション失敗時は無視
  }
};
